import React, { useRef } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useState, useEffect, useref } from 'react';

export const HeadBlockFunc = () => {
  const site = '株式会社ウェブアイディア';
  const [title, setTitle] = useState('');
  const location = useLocation();
  
  useEffect(() => {
    let url;
    let pathName = location.pathname;
    pathName = pathName.replace('/', '');
    pathName = pathName.split('/');
    if(pathName[0] == '/') {
      url = tmp_path.site_url+"/wp-json/wp/v2/";
    } else if(pathName[0] == 'post') {
      url = tmp_path.site_url+'/wp-json/wp/v2' + (pathName[pathName.length - 2] == 'post' ? '/posts' : '/' + pathName[pathName.length - 2]) + '/' + pathName[pathName.length - 1]
    } else {
      url = tmp_path.site_url+"/wp-json/wp/v2/pages?slug="+pathName[0];
    }
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if(pathName[0] == '') {
          setTitle(site);
        } else if(pathName[0] == 'post') {
          setTitle(data.title.rendered+' | '+site);
        } else {
          setTitle(data[0].title.rendered+' | '+site);
        }
      });

  }, [location]);
  
  return(
    <Helmet>
      <title>{title ?? site}</title>
      <meta name="description" content="" />
    </Helmet>
  )
}


class HeadBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      site: '',
      title: props.title,
      description: props.description,
      path: props.path,
    }
  }

  componentDidMount() {
    let url;
    if(this.state.path == '/') {
      url = tmp_path.site_url+"/wp-json/wp/v2/";
    } else {
      url = tmp_path.site_url+"/wp-json/wp/v2/pages?slug="+this.state.path;
    }
    axios
      .get(url)
      .then(response => {
        if(this.state.path == '/') {
          this.setState({
            title: this.state.site,
          });
        } else {
          this.setState({
            title: response.data[0].title.rendered + ' | ' + this.state.site,
          });
        }
      })
      .catch(error => console.log(error));
  }
  render() {
    return (
      <Helmet>
        <title>{this.state.title ?? this.state.site}</title>
        <meta name="description" content="" />
      </Helmet>
    );
  }
};

export default HeadBlock;
